const getIdFromReference = (reference) => {
    let id = undefined;
    if (reference && typeof reference === "object") {
        id = reference.reference?.replace("#", "") || reference.identifier?.value || reference.display;
        if (id?.split("/").length === 2) {
            id = id.split("/")[1];
        }
    }
    return id;
}
export default getIdFromReference;